import styled, {keyframes} from 'styled-components';
import {
    AI_BRAND_GRADIENT_HORIZONTAL,
} from '../../../aiMessageGenerator/aiGeneratorButton/AIGeneratorButton.css';
import {mobileMedia} from '../../../../globalVariables/GlobalVariables';
import zIndex from '../../../../globalVariables/zIndex';
import {AI_AGENT_FAB_SIZE_PX} from '../../../../constants/floatingButtons';

const fabGlow = keyframes`
    0%, 100% { opacity: 0.5; }
    50% { opacity: 0.85; }
`;

const fabRing = keyframes`
    0% { transform: scale(1); opacity: 0.5; }
    70%, 100% { transform: scale(1.65); opacity: 0; }
`;

export const fab = styled.button`
    --ai-grad: ${AI_BRAND_GRADIENT_HORIZONTAL};
    position: fixed;
    inset-inline-end: var(--space-lg);
    bottom: var(--space-lg);
    z-index: ${zIndex.highestModal};
    width: ${AI_AGENT_FAB_SIZE_PX}px;
    height: ${AI_AGENT_FAB_SIZE_PX}px;
    padding: 3px;
    border: none;
    border-radius: var(--border-radius-border-radius-full);
    background: var(--ai-grad);
    cursor: pointer;
    transition: transform 0.15s ease;
    -webkit-tap-highlight-color: transparent;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);

    &::before {
        content: '';
        position: absolute;
        inset: -7px;
        border-radius: inherit;
        background: var(--ai-grad);
        filter: blur(11px);
        z-index: -1;
        animation: ${fabGlow} 2.2s ease-in-out infinite;
    }

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        background: var(--ai-grad);
        z-index: -1;
        animation: ${fabRing} 2.2s ease-out infinite;
    }

    &:hover {
        transform: scale(1.06);
    }

    &:active {
        transform: scale(0.97);
    }

    @media (prefers-reduced-motion: reduce) {
        &::before,
        &::after {
            animation: none;
        }
    }

    ${mobileMedia} {
        /* Clears the mobile bottom navigation. */
        bottom: calc(${AI_AGENT_FAB_SIZE_PX}px + var(--space-lg));
    }
`;
